/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    common: {
        "confirm": "Confirm",
        "cancle": "Cancle",
        "add": "Add",
        "edit": "Edit",
        "delete": "Delete",
        "save": "Save",
        "disable": "Disable",
        "enable": "Enable",
        "back": "Back",
        "message1": "Password changed successfully",
        "placeholder1": "Please enter a new password",
        "placeholder2": "Please enter the confirmation password",
        "placeholder3": "Combination of numbers, letters or underscores",
        "placeholder4": "Please enter user name",
        "placeholder5": "The user name cannot be greater than 20 characters",
        "placeholder6": "You can only enter numbers, letters, or underscores",
        "placeholder7": "Please select",
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/en_US/common.js